export function normalizePhoneNumber(value: string) {
  const trimmed = value.trim();
  const hasInternationalPrefix = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");

  if (hasInternationalPrefix) {
    return `+${digits}`;
  }

  if (digits.startsWith("00")) {
    return `+${digits.slice(2)}`;
  }

  if (digits.startsWith("0")) {
    return `+49${digits.slice(1)}`;
  }

  return digits;
}

export function maskPhoneNumber(value: string) {
  const normalized = normalizePhoneNumber(value);
  const suffix = normalized.slice(-3);
  const prefix = normalized.startsWith("+49") ? "+49" : normalized.slice(0, 3);

  return `${prefix} *** *** ${suffix}`;
}
